/**
 *
 * Asynchronously loads the component for CreateAccessControlPermissions
 *
 */
import Loadable from 'react-loadable';
export default Loadable({
    loader: function () {
        return import(/* webpackChunkName: 'CreateAccessControlPermissions' */ './index');
    },
    loading: function (props) {
        if (props.error) {
            console.error(props.error);
        }
        return null;
    },
});
